// CAIXA ALTA global: força maiúsculas em TODOS os campos de texto do app
// (cadastros, formulários, buscas) sem precisar mexer em cada input.
//
// Como funciona: um listener de 'input' em fase de CAPTURA roda ANTES do React
// ler o onChange. A gente põe o valor em maiúsculas direto no DOM (via setter
// nativo, pra o React detectar a mudança) — então o estado controlado já recebe
// em CAIXA ALTA e o que é salvo no banco também fica maiúsculo.
//
// Exceções (NÃO viram maiúsculo): e-mail e senha (quebraria login), URL/links e
// qualquer campo marcado com `data-no-upper` ou classe `lowercase`/`no-upper`.

const TIPOS_TEXTO = new Set(['', 'text', 'search', 'tel'])
const PADRAO_EXCLUI = /(mail|senha|password|pwd|\burl\b|link|http|site)/i

function optOut(el: HTMLElement): boolean {
  if (el.hasAttribute('data-no-upper')) return true
  const cls = typeof el.className === 'string' ? el.className : ''
  return /\b(no-upper|lowercase|normal-case)\b/.test(cls)
}

function elegivel(el: EventTarget | null): el is HTMLInputElement | HTMLTextAreaElement {
  if (el instanceof HTMLTextAreaElement) return !optOut(el)
  if (el instanceof HTMLInputElement) {
    const tipo = (el.getAttribute('type') || '').toLowerCase()
    if (!TIPOS_TEXTO.has(tipo)) return false               // email/password/number/date/url/... fora
    if ((el.inputMode || '').toLowerCase() === 'email') return false
    const meta = `${el.name} ${el.id} ${el.getAttribute('autocomplete') || ''} ${el.placeholder || ''}`
    if (PADRAO_EXCLUI.test(meta)) return false             // campos de e-mail/senha/url em type=text
    return !optOut(el)
  }
  return false
}

function setValorNativo(el: HTMLInputElement | HTMLTextAreaElement, v: string) {
  const proto = el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype
  const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set
  if (setter) setter.call(el, v)
  else el.value = v
}

export function instalarCaixaAlta() {
  document.addEventListener('input', (e) => {
    const el = e.target
    if (!elegivel(el)) return
    const v = el.value
    const up = v.toUpperCase()
    if (up === v) return
    const ini = el.selectionStart
    const fim = el.selectionEnd
    setValorNativo(el, up)
    try { if (ini != null && fim != null) el.setSelectionRange(ini, fim) } catch { /* type sem seleção */ }
  }, true)
}
